import { render, staticRenderFns } from "./RsaPazienteSchedaProgrammaRiabilitativoModalEdit.vue?vue&type=template&id=4a340efd"
import script from "./RsaPazienteSchedaProgrammaRiabilitativoModalEdit.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSchedaProgrammaRiabilitativoModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports